module.exports = __webpack_public_path__ + "static/img/logo.615bf0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = 81
// module chunks = 0